export const getBuildHeight = ({ extraPxToReduce = 0, extraPxToAdd = 0 } = {}) => {
  const appToolbar = 64
  const marginToolbarToContainer = 24
  const extraMarginBottom = 64
  const sectionHeader = 90
  const innerPadding = 32
  const pageSelector = 51
  return `calc(100vh - ${appToolbar}px - ${marginToolbarToContainer}px - ${sectionHeader}px - ${innerPadding}px - ${pageSelector}px - ${extraMarginBottom}px - ${extraPxToReduce}px + ${extraPxToAdd}px)`
}
